import React, { useState, useEffect, useContext } from "react";
import { useQuery } from "react-query";
import axios from "axios"
import styles from "../styles/MyAssigned.module.css";
import { useHistory } from "react-router-dom";
import Modal from "./../../../modal/Modal";
import ReviewModal from "../../riskportfolio/components/review-modal/ReviewModal";
import { UserContext } from "../../../contexts/UserContext";
import frequencyOverdue from '../../../functions/frequencyOverdue.js'
import Tooltip from "../../../components/tooltip/Tooltip";

export default function MyAssignedControllers() {
    const { setSideBarActiveItem, activeUser } = useContext(UserContext)
    const history = useHistory()
    const [showModal, setShowModal] = useState(false)
    const [activeReview, setActiveReview] = useState(null)
    const [riskIdObject, setRiskIdObject] = useState({})
    const [updateState, setUpdateState] = useState(false)

    const readControllerData = async () => {
        const res = await axios.post(process.env.REACT_APP_IC_SERVICE + "/riskportfolio/get-assigned-controllers",
            {},
            { headers: { authorization: "Bearer " + activeUser.token, }, }
        );
        return res.data;
    };

    const { data: controllerData, status: controllerStatus, refetch } = useQuery(["controllerDataQuery"],
        readControllerData, { enabled: true });

    useEffect(() => {
        refetch()
    }, [updateState, refetch])

    return (
        <>
            <Modal open={showModal} onClose={() => setShowModal(false)}>
                <ReviewModal
                    setShowModal={setShowModal}
                    risk={riskIdObject}
                    activeReview={activeReview}
                    setUpdateState={setUpdateState}
                />
            </Modal>

            <div className={styles.container}>
                <div className={styles.header}>MINA RISKHANTERINGSÅTGÄRDER</div>
                <div className={styles.titleRowDiv}>
                    <div className={styles.colDivRiskName}>Riskhanteringsåtgärd</div>
                    <div className={styles.colDiv}>Objekt</div>
                    <div className={styles.colDivRiskName}>Risk</div>
                    <div className={styles.colDivFrequency}>Frekvens</div>
                    <div className={styles.colDivDate}>Senast utförd</div>
                    <div className={styles.colDivCalendar}></div>
                </div>
                {controllerStatus === "success" && controllerData.length > 0 ?
                    controllerData.sort(function (a, b) {
                        var nameA = a.riskName?.toUpperCase()
                        var nameB = b.riskName?.toUpperCase()
                        if (nameA < nameB) { return -1; }
                        if (nameA > nameB) { return 1; }

                        return 0;
                    }).map(control => {
                        return (
                            <div className={styles.rowDiv} key={control._id}>
                                <div className={styles.colDivRiskName}
                                    onClick={() => {
                                        setRiskIdObject({ _id: control.riskId, department: control.department })
                                        setActiveReview(control);
                                        setShowModal(true);
                                    }}
                                >
                                    {control.controllerName.length > 23 ?
                                        <Tooltip content={control.controllerName} direction={"right"}>{control.controllerName.slice(0, 23)}...</Tooltip>
                                        : control.controllerName
                                    }
                                </div>
                                <div className={styles.colDiv}>{control.departmentName}</div>
                                <div className={styles.colDivRiskName} onClick={() => {
                                    setSideBarActiveItem("riskportfolio")
                                    history.push("/show-risk", {
                                        riskId: control.riskId
                                    })
                                }}>
                                    {control.riskName.length > 30 ?
                                        <Tooltip content={control.riskName} direction={"right"}>{control.riskName.slice(0, 30)}...</Tooltip>
                                        : control.riskName
                                    }
                                </div>
                                <div className={styles.colDivFrequency}>{control.frequency}</div>
                                <div className={styles.colDivDate}>{control.lastSalesDate?.toString().slice(0, 10)}</div>
                                <div className={styles.colDivCalendar}>{
                                    // frequencyOverdue([{ date: control.lastSalesDate }], control.frequency) ?
                                    frequencyOverdue(control.lastSalesDate ? [{ date: control.lastSalesDate }] : [], control.frequency, control.createdAt) ?
                                        <div className={styles.riskRowIconItem}><i className={"far fa-calendar-alt"} ></i></div>
                                        : null
                                }</div>
                            </div>
                        )
                    })
                    : <h4 style={{ fontSize: "14px", fontWeight: "400" }}>Det finns inga riskhanteringsåtgärder tilldelade till dig.</h4>
                }
            </div>
        </>
    );
}
